import { useMemo } from "react";
import { SearchAndFilterTypes } from "src/constants";
import { useWeglot } from "src/plugins/weglot";
import { getLanguageName } from "src/services/languages";
import {
  CommonFilterProps,
  FormFilter,
  MultiSelectFilter,
} from "../CommonFilters";

export const PreferredLanguageFilter = (props: CommonFilterProps) => {
  const weglot = useWeglot();

  const preferredLanguageOptions = useMemo(() => {
    if (!weglot?.options.languages.length) return [];

    const preferredLanguageWeglotOptions = weglot.options.languages.map(
      ({ language_to }) => toLanguageOption(language_to)
    );
    const englishLanguage = toLanguageOption(weglot.options.language_from);
    const noPreferredLanguage = {
      label: "No preferred language",
      id: "null",
    };
    return [
      noPreferredLanguage,
      englishLanguage,
      ...preferredLanguageWeglotOptions,
    ];
  }, [weglot]);

  return (
    <FormFilter label="Preferred language">
      <MultiSelectFilter
        filterKey={SearchAndFilterTypes.PreferredLanguage}
        options={preferredLanguageOptions}
        {...props}
        placeholder="Select a language"
      />
    </FormFilter>
  );
};

function toLanguageOption(languageCode: string) {
  return {
    label: getLanguageName(languageCode),
    id: languageCode,
  };
}
